import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { actionCreators } from '../../store/LoginActionsReducers';

class Logout extends Component {
    componentDidMount() {
        this.props.dispatch(actionCreators.signOut());
    }

    render() {
        return (
            <Redirect to="/login" />
        );
    }
}

export default connect()(Logout);



// WEBPACK FOOTER //
// ./src/components/Login/Logout.js